var _path, _circle, _rect, _rect2, _rect3, _rect4, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 97,
    viewBox: "0 0 93 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 34.9231C20 32.1617 22.2386 29.9231 25 29.9231H29.3344C31.0811 29.9231 32.7012 29.0116 33.6079 27.5187L34.8921 25.4044C35.7988 23.9115 37.4189 23 39.1656 23H55.9656C57.7122 23 59.3323 23.9115 60.2391 25.4044L61.5232 27.5187C62.43 29.0116 64.0501 29.9231 65.7967 29.9231H72C74.7614 29.9231 77 32.1617 77 34.9231V60C77 62.7614 74.7614 65 72 65H25C22.2386 65 20 62.7614 20 60V34.9231Z",
    fill: "#404040"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.8429,
    cy: 46.8429,
    r: 40.8429,
    stroke: "#404040",
    strokeWidth: 6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    width: 19,
    height: 5,
    transform: "rotate(90 50 0)",
    fill: "#F1F0F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 75,
    width: 22,
    height: 5,
    transform: "rotate(90 50 75)",
    fill: "#F1F0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 44,
    width: 15,
    height: 5,
    fill: "#F1F0F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 44,
    width: 13,
    height: 5,
    fill: "#F1F0F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.1727,
    cy: 47.0136,
    r: 10.65,
    fill: "#F1F0F0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.8272,
    cy: 37.1682,
    r: 3.66818,
    fill: "#F1F0F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.88a4fde4.svg";
export { ForwardRef as ReactComponent };